import React, { useEffect, useMemo, useState } from "react";
import AdminUserService from "../../../services/adminUserServices";
import { Column, useSortBy, useTable } from "react-table";
import { useForm } from "react-hook-form";
import ButtonWithIcon from "../../../components/StyledComp/ButtonWithIcon";
import ReactModal from "react-modal";
import { Button, Label, PageLink } from "../../../components/StyledComp/StyledComp";
import "../../../Styles/CommonStyles.scss";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useAppSelector } from "../../../store/hooks";



interface AddFormValue {
    SectionName: string | null;
    SectionDescription: string | null;
    Fee: number | null;
    Status: string | null;
}

// interface Istate {
//     data: {
//         SectionName: string;
//         Description: string;
//         Fee: number;
//         Status: string;
//     }
// }

const MemberSection: React.FC = () => {
    const [memberSection, setMemberSection] = useState<any[] | undefined>([]);
    const [dialogTitle, setdialogTitle] = useState<string>('Add Member Section');

    // const [MemberSectionInput, setMemberSectionInput] = useState<string | undefined>();
    // const [Description, setDescription] = useState<string | undefined>();
    // const [Fee, setFee] = useState<number | undefined>();
    // const [Status, setStatus] = useState<number>(1);
    // const [state, setState] = useState<Istate>({
    //     data: {
    //         SectionName: '',
    //         Description: '',
    //         Fee: 0,
    //         Status: '1'
    //     }
    // })
    const [addSectionOpen, setaddSectionOpen] = useState<boolean>(false);
    const [Id, setId] = useState<number>(1);
    const [selectedRow, setSelectedRow] = useState<any | undefined>();
    const [isEdit, setisEdit] = useState<boolean>(false);
    const form = useForm<AddFormValue>();
    const { register, control, handleSubmit, formState, setValue, reset } = form;
    const { errors, touchedFields, dirtyFields } = formState;
    const roleCapabilites = useAppSelector((state) => state.user.roleCapabilities);


    const getMemberSection = async () => {
        const response = await AdminUserService.getMemberSection();
        console.log(response);
        if (response.data.data != null) {
            setMemberSection(response.data.data);
        } else {
            alert(response.data.errors[0]);
        }
    };
    useEffect(() => {
        getMemberSection();
    }, []);

    const addMemberSection = async (data: any) => {
        const response = await AdminUserService.addMemberSection(data);
        console.log(response);
        if (response.data.data != null) {
            // setMemberSection(response.data.data);
            getMemberSection()
            setaddSectionOpen(false)
            alert('Member Section Added Successfully');

        } else {
            alert(response.data.errors[0]);
        }
    };

    const updateMemberSection = async (data: any) => {
        const response = await AdminUserService.updateMemberSection(data);
        console.log(response);
        if (response.data.data != null) {
            // setMemberSection(response.data.data);
            getMemberSection()
            setaddSectionOpen(false)
            alert('Member Section Updated Successfully');

        } else {
            alert(response.data.errors[0]);
        }
    };

    const columns = React.useMemo<Column<any>[]>(
        () => [
            { id: "Id", Header: "ID", accessor: "Id" },
            { id: "SectionName", Header: "Section Name", accessor: "SectionName" },
            { id: "SectionDescription", Header: "Description", accessor: "SectionDescription" },
            { id: "Fee", Header: "Fee", accessor: "Fee" },
            {
                id: "Status", Header: "Status Id", accessor: "Status",
                Cell: ({ value }: { value: number }) => (
                    <span>{value === 1 ? 'Active' : 'Inactive'}</span>
                )
            },
            {
                id: "edit",
                Header: "Action",
                accessor: (row: any) => (
                    <a className="d-flex editRow justify-content-center" onClick={() => handleEdit(row)}><EditIcon></EditIcon></a>
                ),
            }
        ],
        []
    );

    const handleEdit = (rowData: any) => {
        if (!roleCapabilites.some((obj: any) => Object.values(obj).includes('settings.edit'))) {
            alert("No Access");
            return;
        }
        console.log("Edit clicked for row:", rowData);
        reset()
        setisEdit(true)
        setSelectedRow(rowData);
        // setState({
        //     data: {
        //         SectionName: rowData.SectionName,
        //         Description: rowData.SectionDescription,
        //         Fee: rowData.Fee,
        //         Status: rowData.Status
        //     }
        // })
        setValue('SectionName', rowData.SectionName)
        setValue('SectionDescription', rowData.SectionDescription)
        setValue('Fee', rowData.Fee)
        setValue('Status', rowData.Status)
        // console.log(state)
        // setMemberSectionInput(rowData.SectionName);
        // setDescription(rowData.SectionDescription);
        // setFee(rowData.Fee);
        // setStatus(rowData.Status);
        setId(rowData.Id)
        setaddSectionOpen(true);
        setdialogTitle('Update Member Section')

    };

    const data = useMemo(() => memberSection, [memberSection])!;

    const TableInstance = useTable({
        columns,
        data,
    }, useSortBy);

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
        TableInstance;
    let index = 0;


    const onSubmit = (data: AddFormValue) => {
        const sectionName = data.SectionName || '';
        const SectionDescription = data.SectionDescription || '';
        const status = data.Status !== undefined ? data.Status : '';
        const Fee = data.Fee !== undefined ? data.Fee : '';

        // let data = {
        //     'SectionName': MemberSectionInput,
        //     'SectionDescription': Description,
        //     'Fee': Fee,
        //     'Status': Status
        // }
        const formData = {
            SectionName: sectionName,
            SectionDescription: SectionDescription,
            Status: status,
            Fee: Fee
        };
        let id = {
            'Id': Id
        }
        console.log("SUBMIT");
        // console.log(e)
        console.log(data)
        console.log(formData)
        isEdit ? updateMemberSection({ ...formData, ...id }) : addMemberSection(formData)
    };

    // const updateInput = (event: any): void => {
    //     console.log(event.target.name, event.target.value)
    //     // switch (event.target.name) {
    //     //     case "SectionName":
    //     //         setMemberSectionInput(event.target.value);
    //     //         console.log(MemberSectionInput)
    //     //         break;
    //     //     case "Description":
    //     //         setDescription(event.target.value)
    //     //         break;
    //     //     case "Fee":
    //     //         setFee(parseInt(event.target.value))
    //     //         break;
    //     //     default:
    //     //         break;
    //     // }
    //     setState({
    //         data: {
    //             ...state.data,
    //             [event.target.name]: event.target.value,
    //         },
    //     });
    // };

    // const updateStatus = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    //     console.log(event.target.name, event.target.value)
    //     setStatus(parseInt(event.target.value))

    // };

    const openDialog = () => {
        if (! roleCapabilites.some((obj: any) => Object.values(obj).includes('settings.create'))) {
            alert("No Access");
            return;
          }
        setisEdit(false)
        // setMemberSectionInput('')
        // setDescription('')
        // setFee(undefined)
        // setStatus(1)
        // setState({
        //     data: {
        //         SectionName: '',
        //         Description: '',
        //         Fee: 0,
        //         Status: '1'
        //     }
        // })
        setValue('SectionName', '')
        setValue('SectionDescription', '')
        setValue('Fee', 0)
        setValue('Status', '1')
        setdialogTitle('Add Member Section')

        setaddSectionOpen(true)
    }

    // const handleClose = () = >{

    // }

    const handleClose = () => {
        reset()
        setaddSectionOpen(false)
    }

    return (
        <div className="container-fluid">
            <div className="dashboard-content-wrapper">
                <div className="d-flex justify-content-between" style={{ width: "90%" }}>
                    <h1 className="page-heading">Member Section</h1>
                    <div className="settings-add-button ms-4">
                        <div className="secondary-button" onClick={() => openDialog()}>
                            <AddCircleOutlineIcon></AddCircleOutlineIcon>
                            <span className="ps-1">Add Member Section</span>
                        </div>
                        {/* <ButtonWithIcon
                            icon={<></>}
                            buttontext="Add Member Section"
                            onClick={() => openDialog()}
                        /> */}
                    </div>

                </div>
                <div className="memberSection-table">
                    <table {...getTableProps}>
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps} key={index++}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()} key={column.id}>
                                            {column.render("Header")}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps}>
                            {rows.map((row) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()} key={row.index}>
                                        {row.cells.map((cell) => {
                                            return (
                                                <td {...cell.getCellProps()}> {cell.render("Cell")}</td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <ReactModal isOpen={addSectionOpen} className="addtype-modal" overlayClassName="overlay">
                <div
                    className="horizontal-wrapper-spacebetween"
                    style={{ marginBottom: "1rem", zIndex: "20", height: "5%" }}
                >
                    <h1
                        className="page-heading"
                    // style={{ marginBottom: "2rem", }}
                    >
                        {dialogTitle}
                    </h1>
                    <PageLink
                        onClick={() => handleClose()}
                        style={{ marginBottom: "1rem" }}
                    >
                        Cancel
                    </PageLink>
                </div>
                <form

                    onSubmit={handleSubmit(onSubmit)}
                >
                    <div className="d-flex">
                        <div className="input-field-div-wrapper w-100">
                            <Label>Section Name</Label>
                            <input
                                className="input-field-div"
                                placeholder="Section Name"
                                {...register("SectionName", { required: "Section Name is required" })}
                                name="SectionName" id="SectionName"
                                autoComplete="off"
                            />
                            <p className="form-error form-error-position">
                                {errors.SectionName?.message}
                            </p>
                        </div>
                        <div className="input-field-div-wrapper w-100 mx-3">
                            <Label>Description</Label>
                            <input
                                className="input-field-div"
                                placeholder="Description"
                                {...register("SectionDescription", { required: false })}
                                name="SectionDescription" id="SectionDescription"
                                autoComplete="off"
                            />
                            {/* <p className="form-error form-error-position">
                                {errors.Description?.message}
                            </p> */}
                        </div>
                        <div className="input-field-div-wrapper w-100">
                            <Label>Fee</Label>
                            <input
                                className="input-field-div"
                                placeholder="Fee"
                                {...register("Fee", {
                                    required: "Fee is required",
                                    pattern: {
                                        value: /^[0-9]*$/,
                                        message: "Fee must be a number",
                                    },
                                })}
                                name="Fee" id="Fee"
                                autoComplete="off"
                            />
                            <p className="form-error form-error-position">
                                {errors.Fee?.message}
                            </p>
                        </div>
                    </div>

                    <div className="d-flex">
                        <select style={{ marginTop: "6px" }}
                            className="dropdown-control-large"
                            {...register("Status", { required: false })}
                            name="Status"
                            id='Status'
                        >
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                        </select>
                        {/* <p className="form-error form-error-position">
                            {errors.Status?.message}
                        </p> */}
                    </div>
                    <div className="w-100 d-flex justify-content-center">
                        <div className="submit-button-div">
                            <Button type="submit">{isEdit ? 'Update' : 'Add'}</Button>
                        </div>
                    </div>
                </form>
            </ReactModal>
        </div>

    );
}

export default MemberSection